"use client";;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();
import type {StaticImageData} from "next/image";
import type React from "react";
import Container from "@/components/Container";
import {Media} from "@/components/Media";
import type {Footer, Form} from "@/payload-types";
import "./index.scss";
import Link from "next/link";
import {FormBlock} from "@/blocks/Form/Component";
import {CMSLink} from "@/components/Link";
import RichText from "@/components/RichText";
import {SocialMedia} from "@/components/SocialMedia";

interface FooterClientProps {
	data: Footer;
	staticImage?: StaticImageData;
}

export const FooterClient: React.FC<FooterClientProps> = ({
	data,
	staticImage,
}) => {
	const {
		group1,
		group2,
		group3,
		group4,
		logo,
		footerCreditsMenu,
		subscription,
	} = data;

	return (
		<footer className="footer">
			<Container>
				{logo && (
					<Media src={staticImage} resource={logo} imgClassName="logo" />
				)}
				<div className="footer_groups">
					<div className="footer_group-1">
						<h3>{group1?.title}</h3>
						{group1?.richText && <RichText data={group1?.richText} />}
						<div className="footer_contact-links">
							<p>
								E: <Link href={`mailto:${group1?.email}`}>{group1?.email}</Link>
							</p>
							<p>
								T:{" "}
								<Link href={`tel:${group1?.telephone}`}>
									{group1?.telephone}
								</Link>
							</p>
						</div>
						{group1?.link && <CMSLink {...group1?.link} />}
					</div>
					<div className="footer_group-2">
						<h3>{group2?.title}</h3>
						<nav>
							{(group2?.links || []).map(({ link }, i) => (
								// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
								<CMSLink key={i} {...link} />
							))}
						</nav>
					</div>
					<div className="footer_group-3">
						<h3>{group3?.title}</h3>
						<nav>
							{(group3?.links || []).map(({ link }, i) => (
								// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
								<CMSLink key={i} {...link} />
							))}
						</nav>
						<div className="group-3_social-media">
							{group3?.socialMedia?.map((item, index) => (
								<SocialMedia
									// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
									key={index}
									link={item.link}
									socialMediaPlatform={item.socialMediaPlatform}
								/>
							))}
						</div>
					</div>
					<div className="footer_group-4">
						<h3>{group4?.title}</h3>
						<div className="footer_partners">
							{group4?.partners?.map((item, index) => (
								// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>">
								<Media key={index} src={staticImage} resource={item} />
							))}
						</div>
						{group4?.kmoPortefeuille && (
							<Media
								src={staticImage}
								resource={group4.kmoPortefeuille}
								imgClassName="footer_kmo"
							/>
						)}
					</div>
				</div>
				<div className="group-newsletter">
					{subscription?.title && <h3>{subscription.title}</h3>}
					{subscription?.form && (
						<FormBlock
							blockType="formBlock"
							form={subscription?.form as Form}
							enableIntro
						/>
					)}
				</div>
				<div className="credits">
					<div>
						<p>
							© Encon <span className="hide">-</span>{" "}
						</p>
						<div className="navigation">
							{(footerCreditsMenu || []).map(({ link }, index) => (
								// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
								<CMSLink key={index} {...link} appearance="inline" />
							))}
						</div>
					</div>
				</div>
			</Container>
		</footer>
	);
};
